import {Module, VuexModule, getModule, Mutation, Action} from 'vuex-module-decorators'
import store from '@/store'

import {axios} from "@/plagins";
import {Attachment, DynamicUploadTemplate} from "@/modules/Attachments/types";
import {queryAttachmentsList} from '@/modules/Attachments/metadata'

import user_module from "@/modules/user"

// import lead_module from '@/modules/leadCardSingle/index'

@Module({
  namespaced: true,
  name: 'AttachmentsStore',
  store,
  dynamic: true
})
class LeadAttachmentsStore extends VuexModule {
  attachments: Array<Attachment> = []

  // @Action({rawError: true})
  // async dynamicFileUpload(data: any) {
  //   const fileData = data.fileData
  //   const size = fileData.size
  //   const item = data.item
  //   const attachmentId = data.id
  //   const start = data.start | 0
  //   const step = data.step | 500000
  //
  //   let cnt = 0
  //   let fileStart = start + cnt * step
  //
  //   while (start + cnt * step < size) {
  //     const end = start + (cnt + 1) * step
  //     const part = fileData.slice(start + cnt * step, end > size ? size : end)
  //     const upload = await this.uploadAttachments({id: attachmentId, start: fileStart, data: part})
  //     this.setProgressUpload({item: item, size: (end / size * 100) | 2, id: attachmentId})
  //     fileStart = upload.uploaded
  //     cnt += 1;
  //   }
  //
  //   let finded_attach = this.attachments.find(item => item.Id === attachmentId)
  //   if (finded_attach && finded_attach.progress! > 100) {
  //     this.setProgressUpload({item: item, size: null, id: attachmentId})
  //   }
  // }

  @Mutation
  setProgressUpload(data: any) {
    console.log(">>>>>>> setProgressUpload ---> data: ", data)
    this.attachments.find(item => {
      if (data.id === item.Id) {
        item.progress = data.size || 100
      }
    })
  }

  @Mutation
  setSingleAttachment(attach: Attachment) {
    this.attachments.push(attach)
  }

  @Mutation
  public setAttachments2(data: Array<Attachment>) {

    const preparedData = data.map((t: any) => {
      return {
        ...t,
        Completed: t.completed,
        Created: t.created,
        Data: t.data,
        Id: t.id,
        Info: t.info,
        Status: t.status,
      }
    })

    this.attachments = preparedData || []
  }

  @Action({rawError: true, commit: "setAttachments2"})
  public async getAttachments2() {
    try {

      const data: any = {};

      data.includeStatusesFilter = ["NEW", "SUCCESS", "ACTIVE", "FAULTED"]
			data.appIdsFilter = ["PCT"]
      data.token = user_module.Token;
      data.fingerPrint = user_module.Fingerprint;


      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/ListTasks',
        url: '',
        data: JSON.stringify(data),
        method: 'post',
      })

      // console.log(">>>>>>>>>>>> getAttachments ---> response: ", response)

      if (!response
        || !response.data
        || !response.data
        || !response.data.records
        || !response.data.records.length) {
        return
      } else {
        const len = response.data.records.length
        if (len) {
          for (let r in response.data.records) {
            if (response.data.records[r].Status === 'SUCCESS')
              response.data.records[r].progress = 100
            else response.data.records[r].progress = Number(response.data.records[r].progress)
          }
        }
        // console.log(">>>>>>>response.data.FCT.records : ", response.data.FCT.records)
        return Promise.resolve(response.data.records)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Mutation
  public setAttachments(data: Array<Attachment>) {
    this.attachments = data || []
  }

  @Action({rawError: true, commit: "setAttachments"})
  public async getAttachments(userId: string | (string | null)[]) {
    try {

      const headers = {'content-type': 'multipart/form-data;'}

      const params = {
        // token: user_module.Token,
        login: user_module.Login,
        data: 1,
        action: 'AWSTEXTRACTOR_GET'
      }

      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_URL,
        url: '',
        // data: formData,
        method: 'get',
        headers,
        params
      })

      // console.log(">>>>>>>>>>>> getAttachments ---> response: ", response)

      if (!response
        || !response.data
        || !response.data.FCT
        || !response.data.FCT.records
        || !response.data.FCT.records.length
        || response.data.FCT.Result !== 'Success') {
        return
      } else {
        const len = response.data.FCT.records.length
        if (len) {
          for (let r in response.data.FCT.records) {
            if (response.data.FCT.records[r].Status === 'SUCCESS')
              response.data.FCT.records[r].progress = 100
            else response.data.FCT.records[r].progress = Number(response.data.FCT.records[r].Progress)
          }
        }
        // console.log(">>>>>>>response.data.FCT.records : ", response.data.FCT.records)
        return Promise.resolve(response.data.FCT.records)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  public async savePDF(payload: any) {
    try {

      console.log('payload');

      const data: any = {};

      data.Id = payload.Id
			data.DataManual = payload.data;
      data.token = user_module.Token;
      data.fingerPrint = user_module.Fingerprint;


      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/UpdateTask',
        url: '',
        data: JSON.stringify(data),
        method: 'post',
      })

      console.log(">>>>>>>>>>>> savePDF ---> response: ", response)

      if (!response || !response.data || !response.data.FCT || response.data.FCT.Result !== 'Success') {
        return
      } else {
        return Promise.resolve(response.data.FCT.records)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  public async getFileData(fileId: string | (string | null)[]) {
    try {
      

      const data: any = {};

			data.taskId = fileId;
      data.token = user_module.Token;
      data.fingerPrint = user_module.Fingerprint;

      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/GetTask',
        url: '',
        data: JSON.stringify(data),
        method: 'post',
      })

      console.log(">>>>>>>>>>>> getFileData ---> response: ", response)

      if (!response
        || !response.data
        || !response.data
        || !response.data.record
        ) {
        return
      } else {
        return Promise.resolve(response.data.record)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  public async getFilePDF(payload: any) {
    try {

      const data: any = {};

			data.taskId = payload.fileId;
      data.storageKey = payload.storageKey;
      data.token = user_module.Token;
      data.fingerPrint = user_module.Fingerprint;

      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/GetAttachmentLink',
        url: '',
        data: JSON.stringify(data),
        method: 'post',
      })

      console.log(">>>>>>>>>>>> getFileData ---> response: ", response)

      if (!response || !response.data) {
        return
      } else {
        return Promise.resolve(response.data.url)
      }

    } catch (err) {
      return Promise.reject(err)
    }
  }

  // @Action({rawError: true})
  // public async uploadAttachments(data: DynamicUploadTemplate) {
  //   try {
  //     const headers = {'content-type': 'multipart/form-data;'}
  //     axios.defaults.timeout = 100000;
  //
  //     let formData = new FormData();
  //     formData.append("id", String(data.id));
  //     formData.append("start", String(data.start));
  //     formData.append("data", data.data);
  //
  //     const response: any = await axios.post(`attachments/upload/${data.id}`, formData, {headers})
  //     if (response.data.result !== 'success') {
  //       return
  //     } else {
  //       return Promise.resolve(response.data.data)
  //     }
  //   } catch (err) {
  //     return Promise.reject(err)
  //   }
  // }

  @Action({rawError: true})
  public async insertAttachments(data: Attachment) {
    try {
      const headers = {'content-type': 'multipart/form-data'}

      // const response: any = await axios.post(`attachments/insert`, data)


      let formData = new FormData();

      formData.append('token', user_module.Token);
      formData.append('fingerPrint', user_module.Fingerprint);
      formData.append('Type', 'PARSEPORTFOLIO');
      formData.append('AppId', 'PCT');

      if (data.fileData) formData.append("File", data.fileData);
      // formData.append('from', data.fullPath ? data.fullPath : '');

      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/Create',
        url: '',
        data: formData,
        method: 'post',
        headers,
        // params
      })
      console.log(">>>>>>> insertAttachments ---> response: ", response)
      if (!response.data) {
        return
      } else {
        return Promise.resolve(response.data.id)
      }
    } catch (err) {
      return Promise.reject(err)
    }
  }

  @Action({rawError: true})
  async uploadFile(data: any) {
    try {
      let file = {
        Model: data.isNoteAttach ? 'Notes' : 'Contacts',
        ContentType: data.f.type ? data.f.type : 'form-data',
        Name: data.f.name,
        RowID: data.rowID,
        Size: data.f.size,
        fullPath: data.f.mozFullPath,
        fileData: data.f
      }
      const id = await this.insertAttachments(file as Attachment)
      console.log(">>>>>>>>>> uploadFile ---> attach: ", id)

      console.log('id', id);

      return Promise.resolve(id)
    } catch (err) {

    }
  }

  @Action({rawError: true})
  public async deleteAttachments(attachmentId: string) {
    console.log('>>>>>>💥deleteAttachments ---> attachmentId: 💥', attachmentId)
    try {

      const data: any = {
        taskId: attachmentId,
        fingerPrint: user_module.Fingerprint
      }

      const response: any = await axios({
        baseURL: process.env.VUE_APP_FILES_API_TASK_MANAGER + '/AsyncTask/DeleteTask',
        url: '',
        data: JSON.stringify(data),
        method: 'post',
      })
      console.log('✅RESPONSE✅', response)
      if (response.data.result !== 'success') {
        return
      } else {
        return Promise.resolve(response.data)
      }
    } catch (err) {
      return Promise.reject(err)
    }
    // return Promise.resolve()
  }
}

export default getModule(LeadAttachmentsStore)
